import { render, staticRenderFns } from "./interface-form.vue?vue&type=template&id=15c908cc&scoped=true&"
import script from "./interface-form.vue?vue&type=script&lang=ts&"
export * from "./interface-form.vue?vue&type=script&lang=ts&"
import style0 from "./interface-form.vue?vue&type=style&index=0&id=15c908cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c908cc",
  null
  
)

export default component.exports